export default "__VITE_ASSET__CTTRu7fZ__"